import { FormControl, FormLabel, Grid, Select } from '@chakra-ui/react'
import type { PersonAdditionalData } from 'BrokerTsLib/src/dtos'
import { SelectionType } from 'BrokerTsLib/src/enums'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { SectionHeading } from '@/components/Section/SectionHeading'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'

import { useSelections } from '../../../hooks'
import { useNameof } from '../../../hooks/useNameof'
import InsureeName from './InsureeName'

function AgentPerson({ personPrefix }: { personPrefix: string }) {
  const { isDisabled } = useInsuranceParams()

  const pnameof = useNameof<PersonAdditionalData>(personPrefix)
  const { register, getFieldState, getValues } = useFormContext()

  const { data: dataTitles } = useSelections(SelectionType.TitleBefore)

  const tbPath = pnameof((x) => x.agent!.titleBefore)

  const tbError = getFieldState(tbPath).error

  return (
    <Grid sx={{ w: '100%', gap: 8 }}>
      <SectionHeading>Jednatel / zástupce</SectionHeading>

      <Grid templateColumns="1fr 1fr 1fr" columnGap={{ lg: 16, md: 8 }}>
        <FormControl isInvalid={!!tbError}>
          <FormLabel>Titul před jménem</FormLabel>

          {(dataTitles?.data.length ?? 0) > 0 && (
            <Select
              {...register(tbPath)}
              isDisabled={isDisabled}
              defaultValue={getValues(tbPath) ?? ''}
            >
              <option value="">Vyberte</option>
              {dataTitles?.data.map((item) => (
                <option value={item.value?.toString()} key={item.id}>
                  {item.value}
                </option>
              ))}
            </Select>
          )}
        </FormControl>

        <InsureeName
          personPrefix={pnameof((x) => x.agent)}
          disabled={isDisabled}
        />
      </Grid>
    </Grid>
  )
}

export default AgentPerson
